<template>
  <a
    class="help-center-post-wall-tile__link"
    :href="post.url"
  >
    <HelpCenterPicture
      v-if="post.picture"
      :loading="loading"
      :picture="post.picture"
    />
    <div class="help-center-post-wall-tile__pane">
      <h1 class="help-center-post-wall-tile__title">
        {{ post.title }}
      </h1>
      <p class="help-center-post-wall-tile__summary">
        {{ post.summary }}
      </p>

      <div class="help-center-post-wall-tile__meta">
        <template v-if="author">
          <img
            class="help-center-post-wall-tile__photo"
            :src="author.photo"
            aria-hidden="true"
            loading="lazy"
          />
          <div class="help-center-post-wall-tile__text">
            <span class="help-center-post-wall-tile__name">
              {{ author.name }}
            </span>
            <span class="help-center-post-wall-tile__dot">
              ·
            </span>
            <span class="help-center-post-wall-tile__reading-time">
              {{ post.reading_time }} min read
            </span>
          </div>
        </template>
        <template v-else>
          <span class="help-center-post-wall-tile__reading-time">
            {{ post.reading_time }} min read
          </span>
        </template>
      </div>
    </div>
  </a>
</template>

<script setup>
import { computed } from 'vue'
import HelpCenterPicture from 'help-center/components/HelpCenterPicture'

const props = defineProps({
  post: {
    type: Object,
    required: true
  },
  loading: {
    type: String,
    required: true
  },
  authorMap: {
    type: Object,
    required: true
  }
})

const author = computed(() => {
  return props.authorMap[props.post.author]
})
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-post-wall-tile {
  &__link {
    @include help-center-zoom;
    @include help-center-shadow;
    @include help-center-accent-link($selector: '.help-center-post-wall-tile__title');

    display: flex;
    flex-direction: column;

    border: 1px solid var(--help-center-border);
    overflow: hidden;
    border-radius: 6px;
    background-color: white;
  }

  &__pane {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
  }

  &__title {
    @include help-center-font(20, title);
    color: var(--help-center-accent);
    text-wrap: balance;
    font-weight: var(--help-center-bold);
    margin-bottom: 4px;
  }

  &__summary {
    @include help-center-font(14);
    flex: 1;
    color: var(--help-center-muted);
    margin-bottom: 20px;
  }

  &__meta {
    @include help-center-font(12);
    display: flex;
    gap: 4px;
  }

  &__photo {
    width: 18px;
    height: 18px;
    border-radius: 50%;
  }

  &__text {
    display: flex;
    gap: 0 4px;
    flex-wrap: wrap;
  }

  &__name {
    color: var(--help-center-text);
  }

  &__dot {
    color: var(--help-center-muted);
  }

  &__reading-time {
    color: var(--help-center-muted);
  }
}
</style>
